module.exports = __webpack_public_path__ + "static/media/Mycointainer_362_362.8ce1d5db.png";